
      import Application from './src/app';
      import environment from './src/config';

      Application.create(environment.APP);
    